<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'pre-retirada',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

          <form class="bs-example form-horizontal form-grv">
            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Dados para Retirada / Pagamento
                  </h1>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="clearfix">
                <div class="wrapper">
                  <div class="panel-body">

                    <div class="form-group">
                      <label class="col-sm-2 control-label">GRV</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">820000600 - KVX4650</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Data prevista para retirada</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">22/11/2019</p>
                      </div>
                    </div>

                  </div>
                </div>

                <!---->
                <div class="bg-light lter b-b wrapper-md">
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <h1 class="font-thin h3">
                        Dados do Pagador
                      </h1>
                    </div>
                  </div>
                </div>

                <div class="wrapper">
                  <div class="panel-body">
                    <div class="form-group">
                      <label class="col-sm-2 control-label">Nome</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">Luiz Thomaz Fernandes</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Tipo do documento</label>
                      <div class="col-sm-10">
                        <select class="form-control">
                            <option value="">CPF</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Documento</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">058.511.307-68</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!---->
                <div class="bg-light lter b-b wrapper-md">
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <h1 class="font-thin h3">
                        Endereço Pagador
                      </h1>
                    </div>
                  </div>
                </div>

                <div class="wrapper">
                  <div class="panel-body">
                    <div class="form-group">
                      <label class="col-sm-2 control-label">CEP</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">27253003</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Endereço</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">Rodovia dos Metalúrgicos</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Número</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">480</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Complemento</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">Casa</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Bairro</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">São Geraldo</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Cidade</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">Volta Redonda</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">Rio de Janeiro</label>
                      <div class="col-sm-10">
                        <p class="control-label text-left">Estado</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!---->
                <div class="bg-light lter b-b wrapper-md">
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <h1 class="font-thin h3">
                        Cobrancas
                      </h1>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                    <thead>
                      <tr>
                        <th colspan="2">Tipo</th>
                        <th>Vencimento</th>
                        <th>Descrição</th>
                        <th>valor</th>
                        <th>Desconto</th>
                        <th>Status</th>
                        <th>Atalho</th>
                        <th>Detalhes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Diárias e Reboque para GRV 820000600</td>
                        <td>Normal</td>
                        <td>18/11/2019</td>
                        <td>Diárias e Reboque para GRV 820000600</td>
                        <td>1238,98</td>
                        <td>(Nenhum)</td>
                        <td>PAGO</td>
                        <td>
                          <a class="text-info">
                            Ver Boleto
                          </a>
                        </td>
                        <td><router-link class="text-info" :to="{name: 'cobranca.visualizar'}">Detalhes</router-link></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="wrapper">
                <div class="panel-body">
                  <div class="row">
                    <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv">Salvar</button>
                    <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e adicionar outro(a)</button>
                    <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e continuar editando</button>
                  </div>
                </div>
              </div>
            </div>

          </form>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Retirada.vue?7ec70556